// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WhmcsRouteImport } from './routes/whmcs'
import { Route as VpsRouteImport } from './routes/vps'
import { Route as TestimonialsRouteImport } from './routes/testimonials'
import { Route as TermsOfServiceRouteImport } from './routes/terms-of-service'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SupportRouteImport } from './routes/support'
import { Route as SoftwareRouteImport } from './routes/software'
import { Route as SlaRouteImport } from './routes/sla'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as SearchRouteImport } from './routes/search'
import { Route as ResourcesRouteImport } from './routes/resources'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as RefundPolicyRouteImport } from './routes/refund-policy'
import { Route as RefundRouteImport } from './routes/refund'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PortfolioRouteImport } from './routes/portfolio'
import { Route as PartnersRouteImport } from './routes/partners'
import { Route as MyAccountRouteImport } from './routes/my-account'
import { Route as MarketplaceRouteImport } from './routes/marketplace'
import { Route as MarketingRouteImport } from './routes/marketing'
import { Route as LoginRouteImport } from './routes/login'
import { Route as KbRouteImport } from './routes/kb'
import { Route as HostingRouteImport } from './routes/hosting'
import { Route as GdprRouteImport } from './routes/gdpr'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as FavoritesRouteImport } from './routes/favorites'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as DomainsRouteImport } from './routes/domains'
import { Route as DomainValueRouteImport } from './routes/domain-value'
import { Route as DmcaRouteImport } from './routes/dmca'
import { Route as DisclaimerRouteImport } from './routes/disclaimer'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as CookiePolicyRouteImport } from './routes/cookie-policy'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as CartRouteImport } from './routes/cart'
import { Route as CareersRouteImport } from './routes/careers'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as AcceptableUseRouteImport } from './routes/acceptable-use'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ReceiptOrderIdRouteImport } from './routes/receipt.$orderId'
import { Route as PSlugRouteImport } from './routes/p.$slug'
import { Route as OrdersOrderIdRouteImport } from './routes/orders.$orderId'
import { Route as InvoiceInvoiceIdRouteImport } from './routes/invoice.$invoiceId'
import { Route as SupportIndexRouteImport } from './routes/support.index'
import { Route as SupportChildRouteImport } from './routes/support.$child'
import { Route as SoftwarePosRouteImport } from './routes/software.pos'
import { Route as SoftwareMarketplaceRouteImport } from './routes/software.marketplace'
import { Route as SoftwareLmsRouteImport } from './routes/software.lms'
import { Route as SoftwareInventoryRouteImport } from './routes/software.inventory'
import { Route as SoftwareIndustrySolutionsRouteImport } from './routes/software.industry-solutions'
import { Route as SoftwareHrmPayrollRouteImport } from './routes/software.hrm-payroll'
import { Route as SoftwareHrmRouteImport } from './routes/software.hrm'
import { Route as SoftwareErpRouteImport } from './routes/software.erp'
import { Route as SoftwareCrmRouteImport } from './routes/software.crm'
import { Route as SoftwareBookingRouteImport } from './routes/software.booking'
import { Route as SoftwareAccountingRouteImport } from './routes/software.accounting'
import { Route as ServicesIndexRouteImport } from './routes/services.index'
import { Route as ServicesWebDevelopmentRouteImport } from './routes/services.web-development'
import { Route as ServicesUiUxDesignRouteImport } from './routes/services.ui-ux-design'
import { Route as ServicesTechConsultationRouteImport } from './routes/services.tech-consultation'
import { Route as ServicesSaasDevelopmentRouteImport } from './routes/services.saas-development'
import { Route as ServicesPosSoftwareRouteImport } from './routes/services.pos-software'
import { Route as ServicesMobileAppsRouteImport } from './routes/services.mobile-apps'
import { Route as ServicesMobileApplicationRouteImport } from './routes/services.mobile-application'
import { Route as ServicesMaintenanceRouteImport } from './routes/services.maintenance'
import { Route as ServicesIndustrySolutionsRouteImport } from './routes/services.industry-solutions'
import { Route as ServicesHrmPayrollRouteImport } from './routes/services.hrm-payroll'
import { Route as ServicesErpSolutionRouteImport } from './routes/services.erp-solution'
import { Route as ServicesEcommerceRouteImport } from './routes/services.ecommerce'
import { Route as ServicesDevopsRouteImport } from './routes/services.devops'
import { Route as ServicesApiIntegrationRouteImport } from './routes/services.api-integration'
import { Route as ServicesAiAutomationRouteImport } from './routes/services.ai-automation'
import { Route as ResourcesIndexRouteImport } from './routes/resources.index'
import { Route as ResourcesChildRouteImport } from './routes/resources.$child'
import { Route as PortfolioIndexRouteImport } from './routes/portfolio.index'
import { Route as PortfolioChildRouteImport } from './routes/portfolio.$child'
import { Route as MarketingWhatsappSmsMarketingRouteImport } from './routes/marketing.whatsapp-sms-marketing'
import { Route as MarketingSocialMediaMarketingRouteImport } from './routes/marketing.social-media-marketing'
import { Route as MarketingSocialContentRouteImport } from './routes/marketing.social-content'
import { Route as MarketingSeoServicesRouteImport } from './routes/marketing.seo-services'
import { Route as MarketingSearchSeoRouteImport } from './routes/marketing.search-seo'
import { Route as MarketingPaidAdvertisingRouteImport } from './routes/marketing.paid-advertising'
import { Route as MarketingMarketingAutomationRouteImport } from './routes/marketing.marketing-automation'
import { Route as MarketingLocalSeoRouteImport } from './routes/marketing.local-seo'
import { Route as MarketingLeadGenerationRouteImport } from './routes/marketing.lead-generation'
import { Route as MarketingGoogleAdsPpcRouteImport } from './routes/marketing.google-ads-ppc'
import { Route as MarketingEmailMarketingRouteImport } from './routes/marketing.email-marketing'
import { Route as MarketingEmailAutomationRouteImport } from './routes/marketing.email-automation'
import { Route as MarketingConversionOptimizationRouteImport } from './routes/marketing.conversion-optimization'
import { Route as MarketingContentMarketingRouteImport } from './routes/marketing.content-marketing'
import { Route as MarketingBrandingCreativeDesignRouteImport } from './routes/marketing.branding-creative-design'
import { Route as MarketingAnalyticsTrackingRouteImport } from './routes/marketing.analytics-tracking'
import { Route as MarketingAmazonRouteImport } from './routes/marketing.amazon'
import { Route as KbSlugRouteImport } from './routes/kb.$slug'
import { Route as HostingIndexRouteImport } from './routes/hosting.index'
import { Route as HostingWordpressHostingRouteImport } from './routes/hosting.wordpress-hosting'
import { Route as HostingWhoisRouteImport } from './routes/hosting.whois'
import { Route as HostingWebRouteImport } from './routes/hosting.web'
import { Route as HostingVpsCloudRouteImport } from './routes/hosting.vps-cloud'
import { Route as HostingVpsRouteImport } from './routes/hosting.vps'
import { Route as HostingSslRouteImport } from './routes/hosting.ssl'
import { Route as HostingSharedHostingRouteImport } from './routes/hosting.shared-hosting'
import { Route as HostingResellerHostingRouteImport } from './routes/hosting.reseller-hosting'
import { Route as HostingDomainsRouteImport } from './routes/hosting.domains'
import { Route as HostingDedicatedServersRouteImport } from './routes/hosting.dedicated-servers'
import { Route as HostingDedicatedServerRouteImport } from './routes/hosting.dedicated-server'
import { Route as HostingCloudHostingRouteImport } from './routes/hosting.cloud-hosting'
import { Route as DomainsPricingRouteImport } from './routes/domains.pricing'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as AboutIndexRouteImport } from './routes/about.index'
import { Route as AboutChildRouteImport } from './routes/about.$child'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedAccountRouteImport } from './routes/_authenticated/_account'
import { Route as SoftwarePosIndexRouteImport } from './routes/software.pos.index'
import { Route as SoftwarePosChildRouteImport } from './routes/software.pos.$child'
import { Route as SoftwareIndustrySolutionsIndexRouteImport } from './routes/software.industry-solutions.index'
import { Route as SoftwareIndustrySolutionsChildRouteImport } from './routes/software.industry-solutions.$child'
import { Route as SoftwareErpIndexRouteImport } from './routes/software.erp.index'
import { Route as SoftwareErpChildRouteImport } from './routes/software.erp.$child'
import { Route as ServicesWebDevelopmentIndexRouteImport } from './routes/services.web-development.index'
import { Route as ServicesWebDevelopmentChildRouteImport } from './routes/services.web-development.$child'
import { Route as ServicesUiUxDesignIndexRouteImport } from './routes/services.ui-ux-design.index'
import { Route as ServicesUiUxDesignChildRouteImport } from './routes/services.ui-ux-design.$child'
import { Route as ServicesTechConsultationIndexRouteImport } from './routes/services.tech-consultation.index'
import { Route as ServicesTechConsultationChildRouteImport } from './routes/services.tech-consultation.$child'
import { Route as ServicesPosSoftwareIndexRouteImport } from './routes/services.pos-software.index'
import { Route as ServicesPosSoftwareChildRouteImport } from './routes/services.pos-software.$child'
import { Route as ServicesMobileApplicationIndexRouteImport } from './routes/services.mobile-application.index'
import { Route as ServicesMobileApplicationChildRouteImport } from './routes/services.mobile-application.$child'
import { Route as ServicesIndustrySolutionsIndexRouteImport } from './routes/services.industry-solutions.index'
import { Route as ServicesIndustrySolutionsChildRouteImport } from './routes/services.industry-solutions.$child'
import { Route as ServicesHrmPayrollIndexRouteImport } from './routes/services.hrm-payroll.index'
import { Route as ServicesHrmPayrollChildRouteImport } from './routes/services.hrm-payroll.$child'
import { Route as ServicesErpSolutionIndexRouteImport } from './routes/services.erp-solution.index'
import { Route as ServicesErpSolutionChildRouteImport } from './routes/services.erp-solution.$child'
import { Route as MarketplaceItemSlugRouteImport } from './routes/marketplace.item.$slug'
import { Route as MarketplaceCategorySlugRouteImport } from './routes/marketplace.category.$slug'
import { Route as MarketingSocialContentIndexRouteImport } from './routes/marketing.social-content.index'
import { Route as MarketingSocialContentChildRouteImport } from './routes/marketing.social-content.$child'
import { Route as MarketingSearchSeoIndexRouteImport } from './routes/marketing.search-seo.index'
import { Route as MarketingSearchSeoChildRouteImport } from './routes/marketing.search-seo.$child'
import { Route as MarketingPaidAdvertisingIndexRouteImport } from './routes/marketing.paid-advertising.index'
import { Route as MarketingPaidAdvertisingChildRouteImport } from './routes/marketing.paid-advertising.$child'
import { Route as MarketingLocalSeoSlugRouteImport } from './routes/marketing.local-seo.$slug'
import { Route as MarketingLeadGenerationSlugRouteImport } from './routes/marketing.lead-generation.$slug'
import { Route as MarketingEmailAutomationIndexRouteImport } from './routes/marketing.email-automation.index'
import { Route as MarketingEmailAutomationChildRouteImport } from './routes/marketing.email-automation.$child'
import { Route as MarketingAmazonSlugRouteImport } from './routes/marketing.amazon.$slug'
import { Route as KbCategorySlugRouteImport } from './routes/kb.category.$slug'
import { Route as HostingWebIndexRouteImport } from './routes/hosting.web.index'
import { Route as HostingWebChildRouteImport } from './routes/hosting.web.$child'
import { Route as HostingVpsCloudIndexRouteImport } from './routes/hosting.vps-cloud.index'
import { Route as HostingVpsCloudChildRouteImport } from './routes/hosting.vps-cloud.$child'
import { Route as HostingDomainsIndexRouteImport } from './routes/hosting.domains.index'
import { Route as HostingDomainsChildRouteImport } from './routes/hosting.domains.$child'
import { Route as HostingDedicatedServersIndexRouteImport } from './routes/hosting.dedicated-servers.index'
import { Route as HostingDedicatedServersChildRouteImport } from './routes/hosting.dedicated-servers.$child'
import { Route as BlogCategorySlugRouteImport } from './routes/blog.category.$slug'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin/index'
import { Route as AuthenticatedAdminWhmcsRouteImport } from './routes/_authenticated/admin/whmcs'
import { Route as AuthenticatedAdminWebhookTesterRouteImport } from './routes/_authenticated/admin/webhook-tester'
import { Route as AuthenticatedAdminWalletsRouteImport } from './routes/_authenticated/admin/wallets'
import { Route as AuthenticatedAdminVitalsRouteImport } from './routes/_authenticated/admin/vitals'
import { Route as AuthenticatedAdminUsersRouteImport } from './routes/_authenticated/admin/users'
import { Route as AuthenticatedAdminTopupsRouteImport } from './routes/_authenticated/admin/topups'
import { Route as AuthenticatedAdminTopRelatedRouteImport } from './routes/_authenticated/admin/top-related'
import { Route as AuthenticatedAdminTopBarRouteImport } from './routes/_authenticated/admin/top-bar'
import { Route as AuthenticatedAdminTicketsRouteImport } from './routes/_authenticated/admin/tickets'
import { Route as AuthenticatedAdminTestimonialsRouteImport } from './routes/_authenticated/admin/testimonials'
import { Route as AuthenticatedAdminTeamRouteImport } from './routes/_authenticated/admin/team'
import { Route as AuthenticatedAdminTaxRouteImport } from './routes/_authenticated/admin/tax'
import { Route as AuthenticatedAdminSystemRouteImport } from './routes/_authenticated/admin/system'
import { Route as AuthenticatedAdminSupportPlansRouteImport } from './routes/_authenticated/admin/support-plans'
import { Route as AuthenticatedAdminSoftwareKeysRouteImport } from './routes/_authenticated/admin/software-keys'
import { Route as AuthenticatedAdminSoftwareRouteImport } from './routes/_authenticated/admin/software'
import { Route as AuthenticatedAdminSettingsRouteImport } from './routes/_authenticated/admin/settings'
import { Route as AuthenticatedAdminServicesRouteImport } from './routes/_authenticated/admin/services'
import { Route as AuthenticatedAdminSeoRouteImport } from './routes/_authenticated/admin/seo'
import { Route as AuthenticatedAdminSegmentsRouteImport } from './routes/_authenticated/admin/segments'
import { Route as AuthenticatedAdminRolesRouteImport } from './routes/_authenticated/admin/roles'
import { Route as AuthenticatedAdminReviewsRouteImport } from './routes/_authenticated/admin/reviews'
import { Route as AuthenticatedAdminReferralsRouteImport } from './routes/_authenticated/admin/referrals'
import { Route as AuthenticatedAdminPostsRouteImport } from './routes/_authenticated/admin/posts'
import { Route as AuthenticatedAdminPosRouteImport } from './routes/_authenticated/admin/pos'
import { Route as AuthenticatedAdminPlansRouteImport } from './routes/_authenticated/admin/plans'
import { Route as AuthenticatedAdminPaymentGatewaysRouteImport } from './routes/_authenticated/admin/payment-gateways'
import { Route as AuthenticatedAdminPagesRouteImport } from './routes/_authenticated/admin/pages'
import { Route as AuthenticatedAdminOrdersRouteImport } from './routes/_authenticated/admin/orders'
import { Route as AuthenticatedAdminNotificationsRouteImport } from './routes/_authenticated/admin/notifications'
import { Route as AuthenticatedAdminNavigationRouteImport } from './routes/_authenticated/admin/navigation'
import { Route as AuthenticatedAdminMarketingMenuRouteImport } from './routes/_authenticated/admin/marketing-menu'
import { Route as AuthenticatedAdminLocalizationRouteImport } from './routes/_authenticated/admin/localization'
import { Route as AuthenticatedAdminKbRouteImport } from './routes/_authenticated/admin/kb'
import { Route as AuthenticatedAdminInventoryRouteImport } from './routes/_authenticated/admin/inventory'
import { Route as AuthenticatedAdminIntegrationsRouteImport } from './routes/_authenticated/admin/integrations'
import { Route as AuthenticatedAdminHostingProvidersRouteImport } from './routes/_authenticated/admin/hosting-providers'
import { Route as AuthenticatedAdminHostingContentRouteImport } from './routes/_authenticated/admin/hosting-content'
import { Route as AuthenticatedAdminHostingRouteImport } from './routes/_authenticated/admin/hosting'
import { Route as AuthenticatedAdminFrontendPagesRouteImport } from './routes/_authenticated/admin/frontend-pages'
import { Route as AuthenticatedAdminFooterRouteImport } from './routes/_authenticated/admin/footer'
import { Route as AuthenticatedAdminFilesRouteImport } from './routes/_authenticated/admin/files'
import { Route as AuthenticatedAdminFaqsRouteImport } from './routes/_authenticated/admin/faqs'
import { Route as AuthenticatedAdminErpRouteImport } from './routes/_authenticated/admin/erp'
import { Route as AuthenticatedAdminEmailConfigurationsRouteImport } from './routes/_authenticated/admin/email-configurations'
import { Route as AuthenticatedAdminEmailRouteImport } from './routes/_authenticated/admin/email'
import { Route as AuthenticatedAdminDomainsRouteImport } from './routes/_authenticated/admin/domains'
import { Route as AuthenticatedAdminDomainRegistrarsRouteImport } from './routes/_authenticated/admin/domain-registrars'
import { Route as AuthenticatedAdminDigitalMarketplaceRouteImport } from './routes/_authenticated/admin/digital-marketplace'
import { Route as AuthenticatedAdminContentSyncRouteImport } from './routes/_authenticated/admin/content-sync'
import { Route as AuthenticatedAdminChatRouteImport } from './routes/_authenticated/admin/chat'
import { Route as AuthenticatedAdminCategoriesRouteImport } from './routes/_authenticated/admin/categories'
import { Route as AuthenticatedAdminBrandLogosRouteImport } from './routes/_authenticated/admin/brand-logos'
import { Route as AuthenticatedAdminBranchesRouteImport } from './routes/_authenticated/admin/branches'
import { Route as AuthenticatedAdminBranchStaffRouteImport } from './routes/_authenticated/admin/branch-staff'
import { Route as AuthenticatedAdminBranchPerformanceRouteImport } from './routes/_authenticated/admin/branch-performance'
import { Route as AuthenticatedAdminBranchPayoutsRouteImport } from './routes/_authenticated/admin/branch-payouts'
import { Route as AuthenticatedAdminBranchInventoryRouteImport } from './routes/_authenticated/admin/branch-inventory'
import { Route as AuthenticatedAdminAuditRouteImport } from './routes/_authenticated/admin/audit'
import { Route as AuthenticatedAdminAppearanceRouteImport } from './routes/_authenticated/admin/appearance'
import { Route as AuthenticatedAdminApiKeysRouteImport } from './routes/_authenticated/admin/api-keys'
import { Route as AuthenticatedAdminApiDashboardRouteImport } from './routes/_authenticated/admin/api-dashboard'
import { Route as AuthenticatedAdminAnalyticsRouteImport } from './routes/_authenticated/admin/analytics'
import { Route as AuthenticatedAdminAffiliatesRouteImport } from './routes/_authenticated/admin/affiliates'
import { Route as AuthenticatedAccountTicketsRouteImport } from './routes/_authenticated/_account/tickets'
import { Route as AuthenticatedAccountSupportPlansRouteImport } from './routes/_authenticated/_account/support-plans'
import { Route as AuthenticatedAccountSubmitTicketRouteImport } from './routes/_authenticated/_account/submit-ticket'
import { Route as AuthenticatedAccountSecurityRouteImport } from './routes/_authenticated/_account/security'
import { Route as AuthenticatedAccountProfileRouteImport } from './routes/_authenticated/_account/profile'
import { Route as AuthenticatedAccountOrdersRouteImport } from './routes/_authenticated/_account/orders'
import { Route as AuthenticatedAccountNotificationsRouteImport } from './routes/_authenticated/_account/notifications'
import { Route as AuthenticatedAccountLicensesRouteImport } from './routes/_authenticated/_account/licenses'
import { Route as AuthenticatedAccountHelpRouteImport } from './routes/_authenticated/_account/help'
import { Route as AuthenticatedAccountDashboardRouteImport } from './routes/_authenticated/_account/dashboard'
import { Route as AuthenticatedAccountBillingRouteImport } from './routes/_authenticated/_account/billing'
import { Route as AuthenticatedAccountApiKeysRouteImport } from './routes/_authenticated/_account/api-keys'
import { Route as AuthenticatedAccountAffiliateRouteImport } from './routes/_authenticated/_account/affiliate'
import { Route as AuthenticatedAccountTicketsTicketIdRouteImport } from './routes/_authenticated/_account/tickets.$ticketId'

const WhmcsRoute = WhmcsRouteImport.update({
            id: '/whmcs',path: '/whmcs',getParentRoute: () => rootRouteImport
          })
const VpsRoute = VpsRouteImport.update({
            id: '/vps',path: '/vps',getParentRoute: () => rootRouteImport
          })
const TestimonialsRoute = TestimonialsRouteImport.update({
            id: '/testimonials',path: '/testimonials',getParentRoute: () => rootRouteImport
          })
const TermsOfServiceRoute = TermsOfServiceRouteImport.update({
            id: '/terms-of-service',path: '/terms-of-service',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SupportRoute = SupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => rootRouteImport
          })
const SoftwareRoute = SoftwareRouteImport.update({
            id: '/software',path: '/software',getParentRoute: () => rootRouteImport
          })
const SlaRoute = SlaRouteImport.update({
            id: '/sla',path: '/sla',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const SearchRoute = SearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => rootRouteImport
          })
const ResourcesRoute = ResourcesRouteImport.update({
            id: '/resources',path: '/resources',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const RegisterRoute = RegisterRouteImport.update({
            id: '/register',path: '/register',getParentRoute: () => rootRouteImport
          })
const RefundPolicyRoute = RefundPolicyRouteImport.update({
            id: '/refund-policy',path: '/refund-policy',getParentRoute: () => rootRouteImport
          })
const RefundRoute = RefundRouteImport.update({
            id: '/refund',path: '/refund',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PortfolioRoute = PortfolioRouteImport.update({
            id: '/portfolio',path: '/portfolio',getParentRoute: () => rootRouteImport
          })
const PartnersRoute = PartnersRouteImport.update({
            id: '/partners',path: '/partners',getParentRoute: () => rootRouteImport
          })
const MyAccountRoute = MyAccountRouteImport.update({
            id: '/my-account',path: '/my-account',getParentRoute: () => rootRouteImport
          })
const MarketplaceRoute = MarketplaceRouteImport.update({
            id: '/marketplace',path: '/marketplace',getParentRoute: () => rootRouteImport
          })
const MarketingRoute = MarketingRouteImport.update({
            id: '/marketing',path: '/marketing',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const KbRoute = KbRouteImport.update({
            id: '/kb',path: '/kb',getParentRoute: () => rootRouteImport
          })
const HostingRoute = HostingRouteImport.update({
            id: '/hosting',path: '/hosting',getParentRoute: () => rootRouteImport
          })
const GdprRoute = GdprRouteImport.update({
            id: '/gdpr',path: '/gdpr',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const FavoritesRoute = FavoritesRouteImport.update({
            id: '/favorites',path: '/favorites',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const DomainsRoute = DomainsRouteImport.update({
            id: '/domains',path: '/domains',getParentRoute: () => rootRouteImport
          })
const DomainValueRoute = DomainValueRouteImport.update({
            id: '/domain-value',path: '/domain-value',getParentRoute: () => rootRouteImport
          })
const DmcaRoute = DmcaRouteImport.update({
            id: '/dmca',path: '/dmca',getParentRoute: () => rootRouteImport
          })
const DisclaimerRoute = DisclaimerRouteImport.update({
            id: '/disclaimer',path: '/disclaimer',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const CookiePolicyRoute = CookiePolicyRouteImport.update({
            id: '/cookie-policy',path: '/cookie-policy',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CheckoutRoute = CheckoutRouteImport.update({
            id: '/checkout',path: '/checkout',getParentRoute: () => rootRouteImport
          })
const CartRoute = CartRouteImport.update({
            id: '/cart',path: '/cart',getParentRoute: () => rootRouteImport
          })
const CareersRoute = CareersRouteImport.update({
            id: '/careers',path: '/careers',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const AcceptableUseRoute = AcceptableUseRouteImport.update({
            id: '/acceptable-use',path: '/acceptable-use',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRoute = AuthenticatedRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ReceiptOrderIdRoute = ReceiptOrderIdRouteImport.update({
            id: '/receipt/$orderId',path: '/receipt/$orderId',getParentRoute: () => rootRouteImport
          })
const PSlugRoute = PSlugRouteImport.update({
            id: '/p/$slug',path: '/p/$slug',getParentRoute: () => rootRouteImport
          })
const OrdersOrderIdRoute = OrdersOrderIdRouteImport.update({
            id: '/orders/$orderId',path: '/orders/$orderId',getParentRoute: () => rootRouteImport
          })
const InvoiceInvoiceIdRoute = InvoiceInvoiceIdRouteImport.update({
            id: '/invoice/$invoiceId',path: '/invoice/$invoiceId',getParentRoute: () => rootRouteImport
          })
const SupportIndexRoute = SupportIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SupportRoute
          })
const SupportChildRoute = SupportChildRouteImport.update({
            id: '/$child',path: '/$child',getParentRoute: () => SupportRoute
          })
const SoftwarePosRoute = SoftwarePosRouteImport.update({
            id: '/pos',path: '/pos',getParentRoute: () => SoftwareRoute
          })
const SoftwareMarketplaceRoute = SoftwareMarketplaceRouteImport.update({
            id: '/marketplace',path: '/marketplace',getParentRoute: () => SoftwareRoute
          })
const SoftwareLmsRoute = SoftwareLmsRouteImport.update({
            id: '/lms',path: '/lms',getParentRoute: () => SoftwareRoute
          })
const SoftwareInventoryRoute = SoftwareInventoryRouteImport.update({
            id: '/inventory',path: '/inventory',getParentRoute: () => SoftwareRoute
          })
const SoftwareIndustrySolutionsRoute = SoftwareIndustrySolutionsRouteImport.update({
            id: '/industry-solutions',path: '/industry-solutions',getParentRoute: () => SoftwareRoute
          })
const SoftwareHrmPayrollRoute = SoftwareHrmPayrollRouteImport.update({
            id: '/hrm-payroll',path: '/hrm-payroll',getParentRoute: () => SoftwareRoute
          })
const SoftwareHrmRoute = SoftwareHrmRouteImport.update({
            id: '/hrm',path: '/hrm',getParentRoute: () => SoftwareRoute
          })
const SoftwareErpRoute = SoftwareErpRouteImport.update({
            id: '/erp',path: '/erp',getParentRoute: () => SoftwareRoute
          })
const SoftwareCrmRoute = SoftwareCrmRouteImport.update({
            id: '/crm',path: '/crm',getParentRoute: () => SoftwareRoute
          })
const SoftwareBookingRoute = SoftwareBookingRouteImport.update({
            id: '/booking',path: '/booking',getParentRoute: () => SoftwareRoute
          })
const SoftwareAccountingRoute = SoftwareAccountingRouteImport.update({
            id: '/accounting',path: '/accounting',getParentRoute: () => SoftwareRoute
          })
const ServicesIndexRoute = ServicesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ServicesRoute
          })
const ServicesWebDevelopmentRoute = ServicesWebDevelopmentRouteImport.update({
            id: '/web-development',path: '/web-development',getParentRoute: () => ServicesRoute
          })
const ServicesUiUxDesignRoute = ServicesUiUxDesignRouteImport.update({
            id: '/ui-ux-design',path: '/ui-ux-design',getParentRoute: () => ServicesRoute
          })
const ServicesTechConsultationRoute = ServicesTechConsultationRouteImport.update({
            id: '/tech-consultation',path: '/tech-consultation',getParentRoute: () => ServicesRoute
          })
const ServicesSaasDevelopmentRoute = ServicesSaasDevelopmentRouteImport.update({
            id: '/saas-development',path: '/saas-development',getParentRoute: () => ServicesRoute
          })
const ServicesPosSoftwareRoute = ServicesPosSoftwareRouteImport.update({
            id: '/pos-software',path: '/pos-software',getParentRoute: () => ServicesRoute
          })
const ServicesMobileAppsRoute = ServicesMobileAppsRouteImport.update({
            id: '/mobile-apps',path: '/mobile-apps',getParentRoute: () => ServicesRoute
          })
const ServicesMobileApplicationRoute = ServicesMobileApplicationRouteImport.update({
            id: '/mobile-application',path: '/mobile-application',getParentRoute: () => ServicesRoute
          })
const ServicesMaintenanceRoute = ServicesMaintenanceRouteImport.update({
            id: '/maintenance',path: '/maintenance',getParentRoute: () => ServicesRoute
          })
const ServicesIndustrySolutionsRoute = ServicesIndustrySolutionsRouteImport.update({
            id: '/industry-solutions',path: '/industry-solutions',getParentRoute: () => ServicesRoute
          })
const ServicesHrmPayrollRoute = ServicesHrmPayrollRouteImport.update({
            id: '/hrm-payroll',path: '/hrm-payroll',getParentRoute: () => ServicesRoute
          })
const ServicesErpSolutionRoute = ServicesErpSolutionRouteImport.update({
            id: '/erp-solution',path: '/erp-solution',getParentRoute: () => ServicesRoute
          })
const ServicesEcommerceRoute = ServicesEcommerceRouteImport.update({
            id: '/ecommerce',path: '/ecommerce',getParentRoute: () => ServicesRoute
          })
const ServicesDevopsRoute = ServicesDevopsRouteImport.update({
            id: '/devops',path: '/devops',getParentRoute: () => ServicesRoute
          })
const ServicesApiIntegrationRoute = ServicesApiIntegrationRouteImport.update({
            id: '/api-integration',path: '/api-integration',getParentRoute: () => ServicesRoute
          })
const ServicesAiAutomationRoute = ServicesAiAutomationRouteImport.update({
            id: '/ai-automation',path: '/ai-automation',getParentRoute: () => ServicesRoute
          })
const ResourcesIndexRoute = ResourcesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ResourcesRoute
          })
const ResourcesChildRoute = ResourcesChildRouteImport.update({
            id: '/$child',path: '/$child',getParentRoute: () => ResourcesRoute
          })
const PortfolioIndexRoute = PortfolioIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PortfolioRoute
          })
const PortfolioChildRoute = PortfolioChildRouteImport.update({
            id: '/$child',path: '/$child',getParentRoute: () => PortfolioRoute
          })
const MarketingWhatsappSmsMarketingRoute = MarketingWhatsappSmsMarketingRouteImport.update({
            id: '/whatsapp-sms-marketing',path: '/whatsapp-sms-marketing',getParentRoute: () => MarketingRoute
          })
const MarketingSocialMediaMarketingRoute = MarketingSocialMediaMarketingRouteImport.update({
            id: '/social-media-marketing',path: '/social-media-marketing',getParentRoute: () => MarketingRoute
          })
const MarketingSocialContentRoute = MarketingSocialContentRouteImport.update({
            id: '/social-content',path: '/social-content',getParentRoute: () => MarketingRoute
          })
const MarketingSeoServicesRoute = MarketingSeoServicesRouteImport.update({
            id: '/seo-services',path: '/seo-services',getParentRoute: () => MarketingRoute
          })
const MarketingSearchSeoRoute = MarketingSearchSeoRouteImport.update({
            id: '/search-seo',path: '/search-seo',getParentRoute: () => MarketingRoute
          })
const MarketingPaidAdvertisingRoute = MarketingPaidAdvertisingRouteImport.update({
            id: '/paid-advertising',path: '/paid-advertising',getParentRoute: () => MarketingRoute
          })
const MarketingMarketingAutomationRoute = MarketingMarketingAutomationRouteImport.update({
            id: '/marketing-automation',path: '/marketing-automation',getParentRoute: () => MarketingRoute
          })
const MarketingLocalSeoRoute = MarketingLocalSeoRouteImport.update({
            id: '/local-seo',path: '/local-seo',getParentRoute: () => MarketingRoute
          })
const MarketingLeadGenerationRoute = MarketingLeadGenerationRouteImport.update({
            id: '/lead-generation',path: '/lead-generation',getParentRoute: () => MarketingRoute
          })
const MarketingGoogleAdsPpcRoute = MarketingGoogleAdsPpcRouteImport.update({
            id: '/google-ads-ppc',path: '/google-ads-ppc',getParentRoute: () => MarketingRoute
          })
const MarketingEmailMarketingRoute = MarketingEmailMarketingRouteImport.update({
            id: '/email-marketing',path: '/email-marketing',getParentRoute: () => MarketingRoute
          })
const MarketingEmailAutomationRoute = MarketingEmailAutomationRouteImport.update({
            id: '/email-automation',path: '/email-automation',getParentRoute: () => MarketingRoute
          })
const MarketingConversionOptimizationRoute = MarketingConversionOptimizationRouteImport.update({
            id: '/conversion-optimization',path: '/conversion-optimization',getParentRoute: () => MarketingRoute
          })
const MarketingContentMarketingRoute = MarketingContentMarketingRouteImport.update({
            id: '/content-marketing',path: '/content-marketing',getParentRoute: () => MarketingRoute
          })
const MarketingBrandingCreativeDesignRoute = MarketingBrandingCreativeDesignRouteImport.update({
            id: '/branding-creative-design',path: '/branding-creative-design',getParentRoute: () => MarketingRoute
          })
const MarketingAnalyticsTrackingRoute = MarketingAnalyticsTrackingRouteImport.update({
            id: '/analytics-tracking',path: '/analytics-tracking',getParentRoute: () => MarketingRoute
          })
const MarketingAmazonRoute = MarketingAmazonRouteImport.update({
            id: '/amazon',path: '/amazon',getParentRoute: () => MarketingRoute
          })
const KbSlugRoute = KbSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => KbRoute
          })
const HostingIndexRoute = HostingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HostingRoute
          })
const HostingWordpressHostingRoute = HostingWordpressHostingRouteImport.update({
            id: '/wordpress-hosting',path: '/wordpress-hosting',getParentRoute: () => HostingRoute
          })
const HostingWhoisRoute = HostingWhoisRouteImport.update({
            id: '/whois',path: '/whois',getParentRoute: () => HostingRoute
          })
const HostingWebRoute = HostingWebRouteImport.update({
            id: '/web',path: '/web',getParentRoute: () => HostingRoute
          })
const HostingVpsCloudRoute = HostingVpsCloudRouteImport.update({
            id: '/vps-cloud',path: '/vps-cloud',getParentRoute: () => HostingRoute
          })
const HostingVpsRoute = HostingVpsRouteImport.update({
            id: '/vps',path: '/vps',getParentRoute: () => HostingRoute
          })
const HostingSslRoute = HostingSslRouteImport.update({
            id: '/ssl',path: '/ssl',getParentRoute: () => HostingRoute
          })
const HostingSharedHostingRoute = HostingSharedHostingRouteImport.update({
            id: '/shared-hosting',path: '/shared-hosting',getParentRoute: () => HostingRoute
          })
const HostingResellerHostingRoute = HostingResellerHostingRouteImport.update({
            id: '/reseller-hosting',path: '/reseller-hosting',getParentRoute: () => HostingRoute
          })
const HostingDomainsRoute = HostingDomainsRouteImport.update({
            id: '/domains',path: '/domains',getParentRoute: () => HostingRoute
          })
const HostingDedicatedServersRoute = HostingDedicatedServersRouteImport.update({
            id: '/dedicated-servers',path: '/dedicated-servers',getParentRoute: () => HostingRoute
          })
const HostingDedicatedServerRoute = HostingDedicatedServerRouteImport.update({
            id: '/dedicated-server',path: '/dedicated-server',getParentRoute: () => HostingRoute
          })
const HostingCloudHostingRoute = HostingCloudHostingRouteImport.update({
            id: '/cloud-hosting',path: '/cloud-hosting',getParentRoute: () => HostingRoute
          })
const DomainsPricingRoute = DomainsPricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => DomainsRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })
const AboutIndexRoute = AboutIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AboutRoute
          })
const AboutChildRoute = AboutChildRouteImport.update({
            id: '/$child',path: '/$child',getParentRoute: () => AboutRoute
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
            id: '/_account',getParentRoute: () => AuthenticatedRoute
          })
const SoftwarePosIndexRoute = SoftwarePosIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SoftwarePosRoute
          })
const SoftwarePosChildRoute = SoftwarePosChildRouteImport.update({
            id: '/$child',path: '/$child',getParentRoute: () => SoftwarePosRoute
          })
const SoftwareIndustrySolutionsIndexRoute = SoftwareIndustrySolutionsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SoftwareIndustrySolutionsRoute
          })
const SoftwareIndustrySolutionsChildRoute = SoftwareIndustrySolutionsChildRouteImport.update({
            id: '/$child',path: '/$child',getParentRoute: () => SoftwareIndustrySolutionsRoute
          })
const SoftwareErpIndexRoute = SoftwareErpIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SoftwareErpRoute
          })
const SoftwareErpChildRoute = SoftwareErpChildRouteImport.update({
            id: '/$child',path: '/$child',getParentRoute: () => SoftwareErpRoute
          })
const ServicesWebDevelopmentIndexRoute = ServicesWebDevelopmentIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ServicesWebDevelopmentRoute
          })
const ServicesWebDevelopmentChildRoute = ServicesWebDevelopmentChildRouteImport.update({
            id: '/$child',path: '/$child',getParentRoute: () => ServicesWebDevelopmentRoute
          })
const ServicesUiUxDesignIndexRoute = ServicesUiUxDesignIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ServicesUiUxDesignRoute
          })
const ServicesUiUxDesignChildRoute = ServicesUiUxDesignChildRouteImport.update({
            id: '/$child',path: '/$child',getParentRoute: () => ServicesUiUxDesignRoute
          })
const ServicesTechConsultationIndexRoute = ServicesTechConsultationIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ServicesTechConsultationRoute
          })
const ServicesTechConsultationChildRoute = ServicesTechConsultationChildRouteImport.update({
            id: '/$child',path: '/$child',getParentRoute: () => ServicesTechConsultationRoute
          })
const ServicesPosSoftwareIndexRoute = ServicesPosSoftwareIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ServicesPosSoftwareRoute
          })
const ServicesPosSoftwareChildRoute = ServicesPosSoftwareChildRouteImport.update({
            id: '/$child',path: '/$child',getParentRoute: () => ServicesPosSoftwareRoute
          })
const ServicesMobileApplicationIndexRoute = ServicesMobileApplicationIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ServicesMobileApplicationRoute
          })
const ServicesMobileApplicationChildRoute = ServicesMobileApplicationChildRouteImport.update({
            id: '/$child',path: '/$child',getParentRoute: () => ServicesMobileApplicationRoute
          })
const ServicesIndustrySolutionsIndexRoute = ServicesIndustrySolutionsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ServicesIndustrySolutionsRoute
          })
const ServicesIndustrySolutionsChildRoute = ServicesIndustrySolutionsChildRouteImport.update({
            id: '/$child',path: '/$child',getParentRoute: () => ServicesIndustrySolutionsRoute
          })
const ServicesHrmPayrollIndexRoute = ServicesHrmPayrollIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ServicesHrmPayrollRoute
          })
const ServicesHrmPayrollChildRoute = ServicesHrmPayrollChildRouteImport.update({
            id: '/$child',path: '/$child',getParentRoute: () => ServicesHrmPayrollRoute
          })
const ServicesErpSolutionIndexRoute = ServicesErpSolutionIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ServicesErpSolutionRoute
          })
const ServicesErpSolutionChildRoute = ServicesErpSolutionChildRouteImport.update({
            id: '/$child',path: '/$child',getParentRoute: () => ServicesErpSolutionRoute
          })
const MarketplaceItemSlugRoute = MarketplaceItemSlugRouteImport.update({
            id: '/item/$slug',path: '/item/$slug',getParentRoute: () => MarketplaceRoute
          })
const MarketplaceCategorySlugRoute = MarketplaceCategorySlugRouteImport.update({
            id: '/category/$slug',path: '/category/$slug',getParentRoute: () => MarketplaceRoute
          })
const MarketingSocialContentIndexRoute = MarketingSocialContentIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => MarketingSocialContentRoute
          })
const MarketingSocialContentChildRoute = MarketingSocialContentChildRouteImport.update({
            id: '/$child',path: '/$child',getParentRoute: () => MarketingSocialContentRoute
          })
const MarketingSearchSeoIndexRoute = MarketingSearchSeoIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => MarketingSearchSeoRoute
          })
const MarketingSearchSeoChildRoute = MarketingSearchSeoChildRouteImport.update({
            id: '/$child',path: '/$child',getParentRoute: () => MarketingSearchSeoRoute
          })
const MarketingPaidAdvertisingIndexRoute = MarketingPaidAdvertisingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => MarketingPaidAdvertisingRoute
          })
const MarketingPaidAdvertisingChildRoute = MarketingPaidAdvertisingChildRouteImport.update({
            id: '/$child',path: '/$child',getParentRoute: () => MarketingPaidAdvertisingRoute
          })
const MarketingLocalSeoSlugRoute = MarketingLocalSeoSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => MarketingLocalSeoRoute
          })
const MarketingLeadGenerationSlugRoute = MarketingLeadGenerationSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => MarketingLeadGenerationRoute
          })
const MarketingEmailAutomationIndexRoute = MarketingEmailAutomationIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => MarketingEmailAutomationRoute
          })
const MarketingEmailAutomationChildRoute = MarketingEmailAutomationChildRouteImport.update({
            id: '/$child',path: '/$child',getParentRoute: () => MarketingEmailAutomationRoute
          })
const MarketingAmazonSlugRoute = MarketingAmazonSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => MarketingAmazonRoute
          })
const KbCategorySlugRoute = KbCategorySlugRouteImport.update({
            id: '/category/$slug',path: '/category/$slug',getParentRoute: () => KbRoute
          })
const HostingWebIndexRoute = HostingWebIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HostingWebRoute
          })
const HostingWebChildRoute = HostingWebChildRouteImport.update({
            id: '/$child',path: '/$child',getParentRoute: () => HostingWebRoute
          })
const HostingVpsCloudIndexRoute = HostingVpsCloudIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HostingVpsCloudRoute
          })
const HostingVpsCloudChildRoute = HostingVpsCloudChildRouteImport.update({
            id: '/$child',path: '/$child',getParentRoute: () => HostingVpsCloudRoute
          })
const HostingDomainsIndexRoute = HostingDomainsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HostingDomainsRoute
          })
const HostingDomainsChildRoute = HostingDomainsChildRouteImport.update({
            id: '/$child',path: '/$child',getParentRoute: () => HostingDomainsRoute
          })
const HostingDedicatedServersIndexRoute = HostingDedicatedServersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HostingDedicatedServersRoute
          })
const HostingDedicatedServersChildRoute = HostingDedicatedServersChildRouteImport.update({
            id: '/$child',path: '/$child',getParentRoute: () => HostingDedicatedServersRoute
          })
const BlogCategorySlugRoute = BlogCategorySlugRouteImport.update({
            id: '/category/$slug',path: '/category/$slug',getParentRoute: () => BlogRoute
          })
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminWhmcsRoute = AuthenticatedAdminWhmcsRouteImport.update({
            id: '/whmcs',path: '/whmcs',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminWebhookTesterRoute = AuthenticatedAdminWebhookTesterRouteImport.update({
            id: '/webhook-tester',path: '/webhook-tester',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminWalletsRoute = AuthenticatedAdminWalletsRouteImport.update({
            id: '/wallets',path: '/wallets',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminVitalsRoute = AuthenticatedAdminVitalsRouteImport.update({
            id: '/vitals',path: '/vitals',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminUsersRoute = AuthenticatedAdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminTopupsRoute = AuthenticatedAdminTopupsRouteImport.update({
            id: '/topups',path: '/topups',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminTopRelatedRoute = AuthenticatedAdminTopRelatedRouteImport.update({
            id: '/top-related',path: '/top-related',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminTopBarRoute = AuthenticatedAdminTopBarRouteImport.update({
            id: '/top-bar',path: '/top-bar',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminTicketsRoute = AuthenticatedAdminTicketsRouteImport.update({
            id: '/tickets',path: '/tickets',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminTestimonialsRoute = AuthenticatedAdminTestimonialsRouteImport.update({
            id: '/testimonials',path: '/testimonials',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminTeamRoute = AuthenticatedAdminTeamRouteImport.update({
            id: '/team',path: '/team',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminTaxRoute = AuthenticatedAdminTaxRouteImport.update({
            id: '/tax',path: '/tax',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSystemRoute = AuthenticatedAdminSystemRouteImport.update({
            id: '/system',path: '/system',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSupportPlansRoute = AuthenticatedAdminSupportPlansRouteImport.update({
            id: '/support-plans',path: '/support-plans',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSoftwareKeysRoute = AuthenticatedAdminSoftwareKeysRouteImport.update({
            id: '/software-keys',path: '/software-keys',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSoftwareRoute = AuthenticatedAdminSoftwareRouteImport.update({
            id: '/software',path: '/software',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSettingsRoute = AuthenticatedAdminSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminServicesRoute = AuthenticatedAdminServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSeoRoute = AuthenticatedAdminSeoRouteImport.update({
            id: '/seo',path: '/seo',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSegmentsRoute = AuthenticatedAdminSegmentsRouteImport.update({
            id: '/segments',path: '/segments',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminRolesRoute = AuthenticatedAdminRolesRouteImport.update({
            id: '/roles',path: '/roles',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminReviewsRoute = AuthenticatedAdminReviewsRouteImport.update({
            id: '/reviews',path: '/reviews',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminReferralsRoute = AuthenticatedAdminReferralsRouteImport.update({
            id: '/referrals',path: '/referrals',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminPostsRoute = AuthenticatedAdminPostsRouteImport.update({
            id: '/posts',path: '/posts',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminPosRoute = AuthenticatedAdminPosRouteImport.update({
            id: '/pos',path: '/pos',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminPlansRoute = AuthenticatedAdminPlansRouteImport.update({
            id: '/plans',path: '/plans',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminPaymentGatewaysRoute = AuthenticatedAdminPaymentGatewaysRouteImport.update({
            id: '/payment-gateways',path: '/payment-gateways',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminPagesRoute = AuthenticatedAdminPagesRouteImport.update({
            id: '/pages',path: '/pages',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminOrdersRoute = AuthenticatedAdminOrdersRouteImport.update({
            id: '/orders',path: '/orders',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminNotificationsRoute = AuthenticatedAdminNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminNavigationRoute = AuthenticatedAdminNavigationRouteImport.update({
            id: '/navigation',path: '/navigation',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminMarketingMenuRoute = AuthenticatedAdminMarketingMenuRouteImport.update({
            id: '/marketing-menu',path: '/marketing-menu',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminLocalizationRoute = AuthenticatedAdminLocalizationRouteImport.update({
            id: '/localization',path: '/localization',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminKbRoute = AuthenticatedAdminKbRouteImport.update({
            id: '/kb',path: '/kb',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminInventoryRoute = AuthenticatedAdminInventoryRouteImport.update({
            id: '/inventory',path: '/inventory',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminIntegrationsRoute = AuthenticatedAdminIntegrationsRouteImport.update({
            id: '/integrations',path: '/integrations',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminHostingProvidersRoute = AuthenticatedAdminHostingProvidersRouteImport.update({
            id: '/hosting-providers',path: '/hosting-providers',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminHostingContentRoute = AuthenticatedAdminHostingContentRouteImport.update({
            id: '/hosting-content',path: '/hosting-content',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminHostingRoute = AuthenticatedAdminHostingRouteImport.update({
            id: '/hosting',path: '/hosting',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminFrontendPagesRoute = AuthenticatedAdminFrontendPagesRouteImport.update({
            id: '/frontend-pages',path: '/frontend-pages',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminFooterRoute = AuthenticatedAdminFooterRouteImport.update({
            id: '/footer',path: '/footer',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminFilesRoute = AuthenticatedAdminFilesRouteImport.update({
            id: '/files',path: '/files',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminFaqsRoute = AuthenticatedAdminFaqsRouteImport.update({
            id: '/faqs',path: '/faqs',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminErpRoute = AuthenticatedAdminErpRouteImport.update({
            id: '/erp',path: '/erp',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminEmailConfigurationsRoute = AuthenticatedAdminEmailConfigurationsRouteImport.update({
            id: '/email-configurations',path: '/email-configurations',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminEmailRoute = AuthenticatedAdminEmailRouteImport.update({
            id: '/email',path: '/email',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminDomainsRoute = AuthenticatedAdminDomainsRouteImport.update({
            id: '/domains',path: '/domains',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminDomainRegistrarsRoute = AuthenticatedAdminDomainRegistrarsRouteImport.update({
            id: '/domain-registrars',path: '/domain-registrars',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminDigitalMarketplaceRoute = AuthenticatedAdminDigitalMarketplaceRouteImport.update({
            id: '/digital-marketplace',path: '/digital-marketplace',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminContentSyncRoute = AuthenticatedAdminContentSyncRouteImport.update({
            id: '/content-sync',path: '/content-sync',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminChatRoute = AuthenticatedAdminChatRouteImport.update({
            id: '/chat',path: '/chat',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminCategoriesRoute = AuthenticatedAdminCategoriesRouteImport.update({
            id: '/categories',path: '/categories',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminBrandLogosRoute = AuthenticatedAdminBrandLogosRouteImport.update({
            id: '/brand-logos',path: '/brand-logos',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminBranchesRoute = AuthenticatedAdminBranchesRouteImport.update({
            id: '/branches',path: '/branches',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminBranchStaffRoute = AuthenticatedAdminBranchStaffRouteImport.update({
            id: '/branch-staff',path: '/branch-staff',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminBranchPerformanceRoute = AuthenticatedAdminBranchPerformanceRouteImport.update({
            id: '/branch-performance',path: '/branch-performance',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminBranchPayoutsRoute = AuthenticatedAdminBranchPayoutsRouteImport.update({
            id: '/branch-payouts',path: '/branch-payouts',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminBranchInventoryRoute = AuthenticatedAdminBranchInventoryRouteImport.update({
            id: '/branch-inventory',path: '/branch-inventory',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminAuditRoute = AuthenticatedAdminAuditRouteImport.update({
            id: '/audit',path: '/audit',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminAppearanceRoute = AuthenticatedAdminAppearanceRouteImport.update({
            id: '/appearance',path: '/appearance',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminApiKeysRoute = AuthenticatedAdminApiKeysRouteImport.update({
            id: '/api-keys',path: '/api-keys',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminApiDashboardRoute = AuthenticatedAdminApiDashboardRouteImport.update({
            id: '/api-dashboard',path: '/api-dashboard',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminAnalyticsRoute = AuthenticatedAdminAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminAffiliatesRoute = AuthenticatedAdminAffiliatesRouteImport.update({
            id: '/affiliates',path: '/affiliates',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAccountTicketsRoute = AuthenticatedAccountTicketsRouteImport.update({
            id: '/tickets',path: '/tickets',getParentRoute: () => AuthenticatedAccountRoute
          })
const AuthenticatedAccountSupportPlansRoute = AuthenticatedAccountSupportPlansRouteImport.update({
            id: '/support-plans',path: '/support-plans',getParentRoute: () => AuthenticatedAccountRoute
          })
const AuthenticatedAccountSubmitTicketRoute = AuthenticatedAccountSubmitTicketRouteImport.update({
            id: '/submit-ticket',path: '/submit-ticket',getParentRoute: () => AuthenticatedAccountRoute
          })
const AuthenticatedAccountSecurityRoute = AuthenticatedAccountSecurityRouteImport.update({
            id: '/security',path: '/security',getParentRoute: () => AuthenticatedAccountRoute
          })
const AuthenticatedAccountProfileRoute = AuthenticatedAccountProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AuthenticatedAccountRoute
          })
const AuthenticatedAccountOrdersRoute = AuthenticatedAccountOrdersRouteImport.update({
            id: '/orders',path: '/orders',getParentRoute: () => AuthenticatedAccountRoute
          })
const AuthenticatedAccountNotificationsRoute = AuthenticatedAccountNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => AuthenticatedAccountRoute
          })
const AuthenticatedAccountLicensesRoute = AuthenticatedAccountLicensesRouteImport.update({
            id: '/licenses',path: '/licenses',getParentRoute: () => AuthenticatedAccountRoute
          })
const AuthenticatedAccountHelpRoute = AuthenticatedAccountHelpRouteImport.update({
            id: '/help',path: '/help',getParentRoute: () => AuthenticatedAccountRoute
          })
const AuthenticatedAccountDashboardRoute = AuthenticatedAccountDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedAccountRoute
          })
const AuthenticatedAccountBillingRoute = AuthenticatedAccountBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => AuthenticatedAccountRoute
          })
const AuthenticatedAccountApiKeysRoute = AuthenticatedAccountApiKeysRouteImport.update({
            id: '/api-keys',path: '/api-keys',getParentRoute: () => AuthenticatedAccountRoute
          })
const AuthenticatedAccountAffiliateRoute = AuthenticatedAccountAffiliateRouteImport.update({
            id: '/affiliate',path: '/affiliate',getParentRoute: () => AuthenticatedAccountRoute
          })
const AuthenticatedAccountTicketsTicketIdRoute = AuthenticatedAccountTicketsTicketIdRouteImport.update({
            id: '/$ticketId',path: '/$ticketId',getParentRoute: () => AuthenticatedAccountTicketsRoute
          })





const AuthenticatedAccountTicketsRouteChildren = {
  AuthenticatedAccountTicketsTicketIdRoute: AuthenticatedAccountTicketsTicketIdRoute
}

const AuthenticatedAccountTicketsRouteWithChildren = AuthenticatedAccountTicketsRoute._addFileChildren(AuthenticatedAccountTicketsRouteChildren)



const AuthenticatedAccountRouteChildren = {
  AuthenticatedAccountAffiliateRoute: AuthenticatedAccountAffiliateRoute,AuthenticatedAccountApiKeysRoute: AuthenticatedAccountApiKeysRoute,AuthenticatedAccountBillingRoute: AuthenticatedAccountBillingRoute,AuthenticatedAccountDashboardRoute: AuthenticatedAccountDashboardRoute,AuthenticatedAccountHelpRoute: AuthenticatedAccountHelpRoute,AuthenticatedAccountLicensesRoute: AuthenticatedAccountLicensesRoute,AuthenticatedAccountNotificationsRoute: AuthenticatedAccountNotificationsRoute,AuthenticatedAccountOrdersRoute: AuthenticatedAccountOrdersRoute,AuthenticatedAccountProfileRoute: AuthenticatedAccountProfileRoute,AuthenticatedAccountSecurityRoute: AuthenticatedAccountSecurityRoute,AuthenticatedAccountSubmitTicketRoute: AuthenticatedAccountSubmitTicketRoute,AuthenticatedAccountSupportPlansRoute: AuthenticatedAccountSupportPlansRoute,AuthenticatedAccountTicketsRoute: AuthenticatedAccountTicketsRouteWithChildren
}

const AuthenticatedAccountRouteWithChildren = AuthenticatedAccountRoute._addFileChildren(AuthenticatedAccountRouteChildren)




const AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminAffiliatesRoute: AuthenticatedAdminAffiliatesRoute,AuthenticatedAdminAnalyticsRoute: AuthenticatedAdminAnalyticsRoute,AuthenticatedAdminApiDashboardRoute: AuthenticatedAdminApiDashboardRoute,AuthenticatedAdminApiKeysRoute: AuthenticatedAdminApiKeysRoute,AuthenticatedAdminAppearanceRoute: AuthenticatedAdminAppearanceRoute,AuthenticatedAdminAuditRoute: AuthenticatedAdminAuditRoute,AuthenticatedAdminBranchInventoryRoute: AuthenticatedAdminBranchInventoryRoute,AuthenticatedAdminBranchPayoutsRoute: AuthenticatedAdminBranchPayoutsRoute,AuthenticatedAdminBranchPerformanceRoute: AuthenticatedAdminBranchPerformanceRoute,AuthenticatedAdminBranchStaffRoute: AuthenticatedAdminBranchStaffRoute,AuthenticatedAdminBranchesRoute: AuthenticatedAdminBranchesRoute,AuthenticatedAdminBrandLogosRoute: AuthenticatedAdminBrandLogosRoute,AuthenticatedAdminCategoriesRoute: AuthenticatedAdminCategoriesRoute,AuthenticatedAdminChatRoute: AuthenticatedAdminChatRoute,AuthenticatedAdminContentSyncRoute: AuthenticatedAdminContentSyncRoute,AuthenticatedAdminDigitalMarketplaceRoute: AuthenticatedAdminDigitalMarketplaceRoute,AuthenticatedAdminDomainRegistrarsRoute: AuthenticatedAdminDomainRegistrarsRoute,AuthenticatedAdminDomainsRoute: AuthenticatedAdminDomainsRoute,AuthenticatedAdminEmailRoute: AuthenticatedAdminEmailRoute,AuthenticatedAdminEmailConfigurationsRoute: AuthenticatedAdminEmailConfigurationsRoute,AuthenticatedAdminErpRoute: AuthenticatedAdminErpRoute,AuthenticatedAdminFaqsRoute: AuthenticatedAdminFaqsRoute,AuthenticatedAdminFilesRoute: AuthenticatedAdminFilesRoute,AuthenticatedAdminFooterRoute: AuthenticatedAdminFooterRoute,AuthenticatedAdminFrontendPagesRoute: AuthenticatedAdminFrontendPagesRoute,AuthenticatedAdminHostingRoute: AuthenticatedAdminHostingRoute,AuthenticatedAdminHostingContentRoute: AuthenticatedAdminHostingContentRoute,AuthenticatedAdminHostingProvidersRoute: AuthenticatedAdminHostingProvidersRoute,AuthenticatedAdminIntegrationsRoute: AuthenticatedAdminIntegrationsRoute,AuthenticatedAdminInventoryRoute: AuthenticatedAdminInventoryRoute,AuthenticatedAdminKbRoute: AuthenticatedAdminKbRoute,AuthenticatedAdminLocalizationRoute: AuthenticatedAdminLocalizationRoute,AuthenticatedAdminMarketingMenuRoute: AuthenticatedAdminMarketingMenuRoute,AuthenticatedAdminNavigationRoute: AuthenticatedAdminNavigationRoute,AuthenticatedAdminNotificationsRoute: AuthenticatedAdminNotificationsRoute,AuthenticatedAdminOrdersRoute: AuthenticatedAdminOrdersRoute,AuthenticatedAdminPagesRoute: AuthenticatedAdminPagesRoute,AuthenticatedAdminPaymentGatewaysRoute: AuthenticatedAdminPaymentGatewaysRoute,AuthenticatedAdminPlansRoute: AuthenticatedAdminPlansRoute,AuthenticatedAdminPosRoute: AuthenticatedAdminPosRoute,AuthenticatedAdminPostsRoute: AuthenticatedAdminPostsRoute,AuthenticatedAdminReferralsRoute: AuthenticatedAdminReferralsRoute,AuthenticatedAdminReviewsRoute: AuthenticatedAdminReviewsRoute,AuthenticatedAdminRolesRoute: AuthenticatedAdminRolesRoute,AuthenticatedAdminSegmentsRoute: AuthenticatedAdminSegmentsRoute,AuthenticatedAdminSeoRoute: AuthenticatedAdminSeoRoute,AuthenticatedAdminServicesRoute: AuthenticatedAdminServicesRoute,AuthenticatedAdminSettingsRoute: AuthenticatedAdminSettingsRoute,AuthenticatedAdminSoftwareRoute: AuthenticatedAdminSoftwareRoute,AuthenticatedAdminSoftwareKeysRoute: AuthenticatedAdminSoftwareKeysRoute,AuthenticatedAdminSupportPlansRoute: AuthenticatedAdminSupportPlansRoute,AuthenticatedAdminSystemRoute: AuthenticatedAdminSystemRoute,AuthenticatedAdminTaxRoute: AuthenticatedAdminTaxRoute,AuthenticatedAdminTeamRoute: AuthenticatedAdminTeamRoute,AuthenticatedAdminTestimonialsRoute: AuthenticatedAdminTestimonialsRoute,AuthenticatedAdminTicketsRoute: AuthenticatedAdminTicketsRoute,AuthenticatedAdminTopBarRoute: AuthenticatedAdminTopBarRoute,AuthenticatedAdminTopRelatedRoute: AuthenticatedAdminTopRelatedRoute,AuthenticatedAdminTopupsRoute: AuthenticatedAdminTopupsRoute,AuthenticatedAdminUsersRoute: AuthenticatedAdminUsersRoute,AuthenticatedAdminVitalsRoute: AuthenticatedAdminVitalsRoute,AuthenticatedAdminWalletsRoute: AuthenticatedAdminWalletsRoute,AuthenticatedAdminWebhookTesterRoute: AuthenticatedAdminWebhookTesterRoute,AuthenticatedAdminWhmcsRoute: AuthenticatedAdminWhmcsRoute,AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute
}

const AuthenticatedAdminRouteWithChildren = AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)



const AuthenticatedRouteChildren = {
  AuthenticatedAccountRoute: AuthenticatedAccountRouteWithChildren,AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(AuthenticatedRouteChildren)




const AboutRouteChildren = {
  AboutChildRoute: AboutChildRoute,AboutIndexRoute: AboutIndexRoute
}

const AboutRouteWithChildren = AboutRoute._addFileChildren(AboutRouteChildren)




const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,BlogCategorySlugRoute: BlogCategorySlugRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)




const DomainsRouteChildren = {
  DomainsPricingRoute: DomainsPricingRoute
}

const DomainsRouteWithChildren = DomainsRoute._addFileChildren(DomainsRouteChildren)




const HostingDedicatedServersRouteChildren = {
  HostingDedicatedServersChildRoute: HostingDedicatedServersChildRoute,HostingDedicatedServersIndexRoute: HostingDedicatedServersIndexRoute
}

const HostingDedicatedServersRouteWithChildren = HostingDedicatedServersRoute._addFileChildren(HostingDedicatedServersRouteChildren)




const HostingDomainsRouteChildren = {
  HostingDomainsChildRoute: HostingDomainsChildRoute,HostingDomainsIndexRoute: HostingDomainsIndexRoute
}

const HostingDomainsRouteWithChildren = HostingDomainsRoute._addFileChildren(HostingDomainsRouteChildren)




const HostingVpsCloudRouteChildren = {
  HostingVpsCloudChildRoute: HostingVpsCloudChildRoute,HostingVpsCloudIndexRoute: HostingVpsCloudIndexRoute
}

const HostingVpsCloudRouteWithChildren = HostingVpsCloudRoute._addFileChildren(HostingVpsCloudRouteChildren)




const HostingWebRouteChildren = {
  HostingWebChildRoute: HostingWebChildRoute,HostingWebIndexRoute: HostingWebIndexRoute
}

const HostingWebRouteWithChildren = HostingWebRoute._addFileChildren(HostingWebRouteChildren)



const HostingRouteChildren = {
  HostingCloudHostingRoute: HostingCloudHostingRoute,HostingDedicatedServerRoute: HostingDedicatedServerRoute,HostingDedicatedServersRoute: HostingDedicatedServersRouteWithChildren,HostingDomainsRoute: HostingDomainsRouteWithChildren,HostingResellerHostingRoute: HostingResellerHostingRoute,HostingSharedHostingRoute: HostingSharedHostingRoute,HostingSslRoute: HostingSslRoute,HostingVpsRoute: HostingVpsRoute,HostingVpsCloudRoute: HostingVpsCloudRouteWithChildren,HostingWebRoute: HostingWebRouteWithChildren,HostingWhoisRoute: HostingWhoisRoute,HostingWordpressHostingRoute: HostingWordpressHostingRoute,HostingIndexRoute: HostingIndexRoute
}

const HostingRouteWithChildren = HostingRoute._addFileChildren(HostingRouteChildren)




const KbRouteChildren = {
  KbSlugRoute: KbSlugRoute,KbCategorySlugRoute: KbCategorySlugRoute
}

const KbRouteWithChildren = KbRoute._addFileChildren(KbRouteChildren)




const MarketingAmazonRouteChildren = {
  MarketingAmazonSlugRoute: MarketingAmazonSlugRoute
}

const MarketingAmazonRouteWithChildren = MarketingAmazonRoute._addFileChildren(MarketingAmazonRouteChildren)




const MarketingEmailAutomationRouteChildren = {
  MarketingEmailAutomationChildRoute: MarketingEmailAutomationChildRoute,MarketingEmailAutomationIndexRoute: MarketingEmailAutomationIndexRoute
}

const MarketingEmailAutomationRouteWithChildren = MarketingEmailAutomationRoute._addFileChildren(MarketingEmailAutomationRouteChildren)




const MarketingLeadGenerationRouteChildren = {
  MarketingLeadGenerationSlugRoute: MarketingLeadGenerationSlugRoute
}

const MarketingLeadGenerationRouteWithChildren = MarketingLeadGenerationRoute._addFileChildren(MarketingLeadGenerationRouteChildren)




const MarketingLocalSeoRouteChildren = {
  MarketingLocalSeoSlugRoute: MarketingLocalSeoSlugRoute
}

const MarketingLocalSeoRouteWithChildren = MarketingLocalSeoRoute._addFileChildren(MarketingLocalSeoRouteChildren)




const MarketingPaidAdvertisingRouteChildren = {
  MarketingPaidAdvertisingChildRoute: MarketingPaidAdvertisingChildRoute,MarketingPaidAdvertisingIndexRoute: MarketingPaidAdvertisingIndexRoute
}

const MarketingPaidAdvertisingRouteWithChildren = MarketingPaidAdvertisingRoute._addFileChildren(MarketingPaidAdvertisingRouteChildren)




const MarketingSearchSeoRouteChildren = {
  MarketingSearchSeoChildRoute: MarketingSearchSeoChildRoute,MarketingSearchSeoIndexRoute: MarketingSearchSeoIndexRoute
}

const MarketingSearchSeoRouteWithChildren = MarketingSearchSeoRoute._addFileChildren(MarketingSearchSeoRouteChildren)




const MarketingSocialContentRouteChildren = {
  MarketingSocialContentChildRoute: MarketingSocialContentChildRoute,MarketingSocialContentIndexRoute: MarketingSocialContentIndexRoute
}

const MarketingSocialContentRouteWithChildren = MarketingSocialContentRoute._addFileChildren(MarketingSocialContentRouteChildren)



const MarketingRouteChildren = {
  MarketingAmazonRoute: MarketingAmazonRouteWithChildren,MarketingAnalyticsTrackingRoute: MarketingAnalyticsTrackingRoute,MarketingBrandingCreativeDesignRoute: MarketingBrandingCreativeDesignRoute,MarketingContentMarketingRoute: MarketingContentMarketingRoute,MarketingConversionOptimizationRoute: MarketingConversionOptimizationRoute,MarketingEmailAutomationRoute: MarketingEmailAutomationRouteWithChildren,MarketingEmailMarketingRoute: MarketingEmailMarketingRoute,MarketingGoogleAdsPpcRoute: MarketingGoogleAdsPpcRoute,MarketingLeadGenerationRoute: MarketingLeadGenerationRouteWithChildren,MarketingLocalSeoRoute: MarketingLocalSeoRouteWithChildren,MarketingMarketingAutomationRoute: MarketingMarketingAutomationRoute,MarketingPaidAdvertisingRoute: MarketingPaidAdvertisingRouteWithChildren,MarketingSearchSeoRoute: MarketingSearchSeoRouteWithChildren,MarketingSeoServicesRoute: MarketingSeoServicesRoute,MarketingSocialContentRoute: MarketingSocialContentRouteWithChildren,MarketingSocialMediaMarketingRoute: MarketingSocialMediaMarketingRoute,MarketingWhatsappSmsMarketingRoute: MarketingWhatsappSmsMarketingRoute
}

const MarketingRouteWithChildren = MarketingRoute._addFileChildren(MarketingRouteChildren)




const MarketplaceRouteChildren = {
  MarketplaceCategorySlugRoute: MarketplaceCategorySlugRoute,MarketplaceItemSlugRoute: MarketplaceItemSlugRoute
}

const MarketplaceRouteWithChildren = MarketplaceRoute._addFileChildren(MarketplaceRouteChildren)




const PortfolioRouteChildren = {
  PortfolioChildRoute: PortfolioChildRoute,PortfolioIndexRoute: PortfolioIndexRoute
}

const PortfolioRouteWithChildren = PortfolioRoute._addFileChildren(PortfolioRouteChildren)




const ResourcesRouteChildren = {
  ResourcesChildRoute: ResourcesChildRoute,ResourcesIndexRoute: ResourcesIndexRoute
}

const ResourcesRouteWithChildren = ResourcesRoute._addFileChildren(ResourcesRouteChildren)




const ServicesErpSolutionRouteChildren = {
  ServicesErpSolutionChildRoute: ServicesErpSolutionChildRoute,ServicesErpSolutionIndexRoute: ServicesErpSolutionIndexRoute
}

const ServicesErpSolutionRouteWithChildren = ServicesErpSolutionRoute._addFileChildren(ServicesErpSolutionRouteChildren)




const ServicesHrmPayrollRouteChildren = {
  ServicesHrmPayrollChildRoute: ServicesHrmPayrollChildRoute,ServicesHrmPayrollIndexRoute: ServicesHrmPayrollIndexRoute
}

const ServicesHrmPayrollRouteWithChildren = ServicesHrmPayrollRoute._addFileChildren(ServicesHrmPayrollRouteChildren)




const ServicesIndustrySolutionsRouteChildren = {
  ServicesIndustrySolutionsChildRoute: ServicesIndustrySolutionsChildRoute,ServicesIndustrySolutionsIndexRoute: ServicesIndustrySolutionsIndexRoute
}

const ServicesIndustrySolutionsRouteWithChildren = ServicesIndustrySolutionsRoute._addFileChildren(ServicesIndustrySolutionsRouteChildren)




const ServicesMobileApplicationRouteChildren = {
  ServicesMobileApplicationChildRoute: ServicesMobileApplicationChildRoute,ServicesMobileApplicationIndexRoute: ServicesMobileApplicationIndexRoute
}

const ServicesMobileApplicationRouteWithChildren = ServicesMobileApplicationRoute._addFileChildren(ServicesMobileApplicationRouteChildren)




const ServicesPosSoftwareRouteChildren = {
  ServicesPosSoftwareChildRoute: ServicesPosSoftwareChildRoute,ServicesPosSoftwareIndexRoute: ServicesPosSoftwareIndexRoute
}

const ServicesPosSoftwareRouteWithChildren = ServicesPosSoftwareRoute._addFileChildren(ServicesPosSoftwareRouteChildren)




const ServicesTechConsultationRouteChildren = {
  ServicesTechConsultationChildRoute: ServicesTechConsultationChildRoute,ServicesTechConsultationIndexRoute: ServicesTechConsultationIndexRoute
}

const ServicesTechConsultationRouteWithChildren = ServicesTechConsultationRoute._addFileChildren(ServicesTechConsultationRouteChildren)




const ServicesUiUxDesignRouteChildren = {
  ServicesUiUxDesignChildRoute: ServicesUiUxDesignChildRoute,ServicesUiUxDesignIndexRoute: ServicesUiUxDesignIndexRoute
}

const ServicesUiUxDesignRouteWithChildren = ServicesUiUxDesignRoute._addFileChildren(ServicesUiUxDesignRouteChildren)




const ServicesWebDevelopmentRouteChildren = {
  ServicesWebDevelopmentChildRoute: ServicesWebDevelopmentChildRoute,ServicesWebDevelopmentIndexRoute: ServicesWebDevelopmentIndexRoute
}

const ServicesWebDevelopmentRouteWithChildren = ServicesWebDevelopmentRoute._addFileChildren(ServicesWebDevelopmentRouteChildren)



const ServicesRouteChildren = {
  ServicesAiAutomationRoute: ServicesAiAutomationRoute,ServicesApiIntegrationRoute: ServicesApiIntegrationRoute,ServicesDevopsRoute: ServicesDevopsRoute,ServicesEcommerceRoute: ServicesEcommerceRoute,ServicesErpSolutionRoute: ServicesErpSolutionRouteWithChildren,ServicesHrmPayrollRoute: ServicesHrmPayrollRouteWithChildren,ServicesIndustrySolutionsRoute: ServicesIndustrySolutionsRouteWithChildren,ServicesMaintenanceRoute: ServicesMaintenanceRoute,ServicesMobileApplicationRoute: ServicesMobileApplicationRouteWithChildren,ServicesMobileAppsRoute: ServicesMobileAppsRoute,ServicesPosSoftwareRoute: ServicesPosSoftwareRouteWithChildren,ServicesSaasDevelopmentRoute: ServicesSaasDevelopmentRoute,ServicesTechConsultationRoute: ServicesTechConsultationRouteWithChildren,ServicesUiUxDesignRoute: ServicesUiUxDesignRouteWithChildren,ServicesWebDevelopmentRoute: ServicesWebDevelopmentRouteWithChildren,ServicesIndexRoute: ServicesIndexRoute
}

const ServicesRouteWithChildren = ServicesRoute._addFileChildren(ServicesRouteChildren)




const SoftwareErpRouteChildren = {
  SoftwareErpChildRoute: SoftwareErpChildRoute,SoftwareErpIndexRoute: SoftwareErpIndexRoute
}

const SoftwareErpRouteWithChildren = SoftwareErpRoute._addFileChildren(SoftwareErpRouteChildren)




const SoftwareIndustrySolutionsRouteChildren = {
  SoftwareIndustrySolutionsChildRoute: SoftwareIndustrySolutionsChildRoute,SoftwareIndustrySolutionsIndexRoute: SoftwareIndustrySolutionsIndexRoute
}

const SoftwareIndustrySolutionsRouteWithChildren = SoftwareIndustrySolutionsRoute._addFileChildren(SoftwareIndustrySolutionsRouteChildren)




const SoftwarePosRouteChildren = {
  SoftwarePosChildRoute: SoftwarePosChildRoute,SoftwarePosIndexRoute: SoftwarePosIndexRoute
}

const SoftwarePosRouteWithChildren = SoftwarePosRoute._addFileChildren(SoftwarePosRouteChildren)



const SoftwareRouteChildren = {
  SoftwareAccountingRoute: SoftwareAccountingRoute,SoftwareBookingRoute: SoftwareBookingRoute,SoftwareCrmRoute: SoftwareCrmRoute,SoftwareErpRoute: SoftwareErpRouteWithChildren,SoftwareHrmRoute: SoftwareHrmRoute,SoftwareHrmPayrollRoute: SoftwareHrmPayrollRoute,SoftwareIndustrySolutionsRoute: SoftwareIndustrySolutionsRouteWithChildren,SoftwareInventoryRoute: SoftwareInventoryRoute,SoftwareLmsRoute: SoftwareLmsRoute,SoftwareMarketplaceRoute: SoftwareMarketplaceRoute,SoftwarePosRoute: SoftwarePosRouteWithChildren
}

const SoftwareRouteWithChildren = SoftwareRoute._addFileChildren(SoftwareRouteChildren)




const SupportRouteChildren = {
  SupportChildRoute: SupportChildRoute,SupportIndexRoute: SupportIndexRoute
}

const SupportRouteWithChildren = SupportRoute._addFileChildren(SupportRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRoute: AuthenticatedRouteWithChildren,AboutRoute: AboutRouteWithChildren,AcceptableUseRoute: AcceptableUseRoute,BlogRoute: BlogRouteWithChildren,CareersRoute: CareersRoute,CartRoute: CartRoute,CheckoutRoute: CheckoutRoute,ContactRoute: ContactRoute,CookiePolicyRoute: CookiePolicyRoute,CookiesRoute: CookiesRoute,DisclaimerRoute: DisclaimerRoute,DmcaRoute: DmcaRoute,DomainValueRoute: DomainValueRoute,DomainsRoute: DomainsRouteWithChildren,FaqRoute: FaqRoute,FavoritesRoute: FavoritesRoute,ForgotPasswordRoute: ForgotPasswordRoute,GdprRoute: GdprRoute,HostingRoute: HostingRouteWithChildren,KbRoute: KbRouteWithChildren,LoginRoute: LoginRoute,MarketingRoute: MarketingRouteWithChildren,MarketplaceRoute: MarketplaceRouteWithChildren,MyAccountRoute: MyAccountRoute,PartnersRoute: PartnersRoute,PortfolioRoute: PortfolioRouteWithChildren,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,RefundRoute: RefundRoute,RefundPolicyRoute: RefundPolicyRoute,RegisterRoute: RegisterRoute,ResetPasswordRoute: ResetPasswordRoute,ResourcesRoute: ResourcesRouteWithChildren,SearchRoute: SearchRoute,ServicesRoute: ServicesRouteWithChildren,SignupRoute: SignupRoute,SlaRoute: SlaRoute,SoftwareRoute: SoftwareRouteWithChildren,SupportRoute: SupportRouteWithChildren,TermsRoute: TermsRoute,TermsOfServiceRoute: TermsOfServiceRoute,TestimonialsRoute: TestimonialsRoute,VpsRoute: VpsRoute,WhmcsRoute: WhmcsRoute,InvoiceInvoiceIdRoute: InvoiceInvoiceIdRoute,OrdersOrderIdRoute: OrdersOrderIdRoute,PSlugRoute: PSlugRoute,ReceiptOrderIdRoute: ReceiptOrderIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)